import formatPhone from 'src/functions/formatPhone'
import type { Country } from 'src/types/country'

/**
 * Публичный номер акции и `tel:` для мобильной ссылки.
 */
export default function getPromotionPhone(
  phone: string | number | undefined,
  country?: Country,
): {
  formatted: string
  rawHref: string
} {
  if (phone == null || phone === '') {
    return {
      formatted: '',
      rawHref: '',
    }
  }

  const formatted = String(formatPhone({
    phone,
    country,
  }))
  const raw = formatPhone({
    phone,
    country,
    isRaw: true,
  })

  return {
    formatted,
    rawHref: `tel:${raw}`,
  }
}
